

















































import {functions} from "@/scripts/firebase";
import { NoticeProps } from "@/scripts/datatypes";
import { Component,Mixins} from "vue-property-decorator";
import Notice from "@/components/Notice.vue";
import { ValidationObserver } from 'vee-validate'
import Common from '@/mixins/common'

@Component({
  components: {
    Notice
  }
})

export default class ChangePassword extends Mixins(Common) {
  password = ''
  passwordNew = ''
  isLoading =  false
  notice: NoticeProps = {}

  get observer(){
    return this.$refs.changePasswordValidationObserver as InstanceType<typeof ValidationObserver>
  }

  get email(){
    return this.$store.state.user.email
  }
  
  mounted(){
    console.log('mounted');
  }

  async created() {
    console.trace('created')
  }

  async changePassword(){
    try{
      this.notice = {
				isShow: false,
      }
			
			if(await this.observer.validate()){
        this.$store.commit("setLoading",true);
        this.isLoading = true
        const user = await this.$reauthenticateWithEmail(this.email,this.password);

        await user.updatePassword(this.passwordNew)

        const sendMail = functions.httpsCallable('sendEmail');
        const data = {
          uid: user.uid,
          actionType: 'changedPassword',
          template: {
              subject: this.$t('changedPasswordMail.subject'),
              body: this.$t('changedPasswordMail.body'),
              lang: this.$store.getters.userLang
          }
        }

        try{
          sendMail(data);
        }catch(error){
          //
        }

        this.notice = {
          message: this.$t('changePassword.success') as string,
          isShow: true,
          duration: 0,
          type: {'is-success': true}
        }

        this.password = ''
        this.passwordNew = ''
        this.observer.reset()
      }
    }catch(error) {
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      console.log(errorCode)
      const errorMessage0 = this.$t('changePassword.error') as string
      const errorMessage1 = this.$getErrorMessage(errorCode)
      const errorField = this.$getErrorField(errorCode)
      console.log(errorField)

      if(errorMessage1 && errorField){
      
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
    }finally{
      this.isLoading = false
      this.$store.commit("setLoading",false);
    }
  }
}
